<div *ngIf="displayMode === 'card'" class="card card-header-actions" [class.mb-4]="!noMarginBottom" [class.border-0]="noBorder" [style.margin-bottom]="noMarginBottom ? '0' : null">
  <div class="card-header d-flex justify-content-between align-items-center" *ngIf="showCardTitle">
    <span>{{ cardTitle | translate }}</span>
    <div class="d-flex align-items-center gap-2">
      <ng-content select="[card-header-actions]"></ng-content>
      @if (showButtons) {
      <ng-container *ngTemplateOutlet="buttons"></ng-container>
      }
    </div>
  </div>
  <div class="card-body" [class.ps-0]="noPadding" [class.pb-0]="noMarginBottom" [style.padding-bottom]="noMarginBottom ? '0' : null">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
</div>

<div
  *ngIf="displayMode === 'modal'"
  class="modal-content modal-dialog-scrollable custom-modal"
  [attr.data-testid]="testId"
>
  <div class="modal-header">
    <h4 class="modal-title" [attr.data-testid]="testId ? testId + '-title' : null" *ngIf="showCardTitle">
      <span>{{ cardTitle | translate }}</span>
    </h4>
    <button
      type="button"
      *ngIf="showClose"
      class="btn-close"
      aria-label="Close"
      (click)="dismissModal.emit()"
      [attr.data-testid]="testId ? testId + '-close-x' : null"
    ></button>
  </div>
  <div class="modal-body">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
  <div *ngIf="showButtons" class="modal-footer">
    @if (showButtons) {
    <ng-container *ngTemplateOutlet="buttons"></ng-container>
    }
  </div>
</div>

<ng-template #buttons>
  <div class="p-0" *ngIf="!isDefaultItem">
    <button
      *ngIf="!isSaving && addDeleteButton && (isShowMode || isEditMode)"
      class="btn {{ useSmallButtons ? 'btn-sm' : '' }} btn-danger me-2"
      (click)="deleteItem.emit()"
    >
      <i class="fa fa-trash"></i> {{ "cardForm.delete" | translate }}
    </button>

    <button
      *ngIf="(isEditMode || (addCancelOnShowMode && isShowMode)) && !(isCreateMode && hideCancelInCreateMode) && !hideCancelButton"
      class="btn {{ useSmallButtons ? 'btn-sm' : '' }} btn-light me-2"
      (click)="cancelEdit.emit()"
    >
      <i class="fa fa-times"></i> {{ "cardForm.cancel" | translate }}
    </button>

    <button
      *ngIf="isSaving && (isCreateMode || isEditMode)"
      class="btn {{ useSmallButtons ? 'btn-sm' : '' }} btn-warning me-2"
    >
      <i class="fa fa-spinner fa-spin"></i>
      {{ "cardForm.saving" | translate }}
    </button>

    <button
      *ngIf="!isSaving && !isCreateMode && isEditMode"
      class="btn {{ useSmallButtons ? 'btn-sm' : '' }} btn-primary me-2"
      (click)="editItem.emit()"
    >
      <i class="fa fa-check"></i> {{ editButtonLabel | translate }}
    </button>

    <button
      *ngIf="hasRole && isShowMode && !readOnly"
      class="btn {{ useSmallButtons ? 'btn-sm' : '' }} btn-primary me-2"
      (click)="toggleEditMode.emit()"
    >
      <i class="fa fa-edit"></i> {{ "cardForm.edit" | translate }}
    </button>

    <button
       *ngIf="!isSaving && hasRole && isCreateMode && !centerCreateButton"
       class="btn {{ useSmallButtons ? 'btn-sm' : '' }} btn-success me-2"
       (click)="createItem.emit()"
     >
       <i class="fa fa-plus"></i> {{ createButtonLabel | translate }}
     </button>
  </div>
  
  <div *ngIf="!isDefaultItem && !isSaving && hasRole && isCreateMode && centerCreateButton" class="d-flex justify-content-center w-100">
    <button
      class="btn {{ useSmallButtons ? 'btn-sm' : '' }} btn-success"
      (click)="createItem.emit()"
    >
      <i class="fa fa-plus"></i> {{ createButtonLabel | translate }}
    </button>
  </div>
  <div class="p-0" *ngIf="isDefaultItem">
    <button
      class="btn {{ useSmallButtons ? 'btn-sm' : '' }} btn-light me-2"
      (click)="cancelEdit.emit()"
    >
      <i class="fa fa-times"></i> {{ "cardForm.cancel" | translate }}
    </button>
  </div>
</ng-template>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
